module.exports = __webpack_public_path__ + "static/media/btndirecto.59099ef4.png";